import { PATH_MATCHER_PRIVATE } from './privates';
import { NormalizeURLPath, ParseURLPath } from './functions';
import { ConstructClassWithPrivateMembers } from '../../misc/helpers/ClassWithPrivateMembers';
import { IsObject } from '../../misc/helpers/is/IsObject';
export function ConstructPathMatcher(instance, path) {
    ConstructClassWithPrivateMembers(instance, PATH_MATCHER_PRIVATE);
    var privates = instance[PATH_MATCHER_PRIVATE];
    privates.path = NormalizeURLPath(path);
    var parsedPath = ParseURLPath(privates.path);
    privates.regExp = parsedPath.regExp;
    privates.params = parsedPath.params;
}
export function IsPathMatcher(value) {
    return IsObject(value)
        && value.hasOwnProperty(PATH_MATCHER_PRIVATE);
}
//# sourceMappingURL=constructor.js.map